import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HelpPage } from "@/features/portalmore/HelpPage";

const search = z.object({
  q: z.string().optional(),
  cat: z.string().optional(),
});

/** Portal help centre (P109). Search text in `q`, category in `cat`. */
export const Route = createFileRoute("/portal/help")({
  validateSearch: search,
  component: () => <HelpPage search={Route.useSearch()} />,
});
